module.exports = __webpack_public_path__ + "img/data2.a324f359.png";